module.exports = __webpack_public_path__ + "img/image_present.23e2685c.png";